import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { IFilter } from "../../../components/src/FilterPopover";
import { ISortingData } from "../../../components/src/SortingTableHeader2";
import { makeApiMessage as MakeApiMessage } from '../../../components/src/common'
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey,
  navigateTo
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import moment from "moment";
import { isArray } from "lodash";

export const configJSON = require("./config");

export interface IPromotionType {
  id: number;
  name: string;
}

export interface IPromotionItem {
  id: string;
  type: string;
  attributes: {
    promotion_name: string;
    start_date: string;
    end_date: string;
    status: string;
    promotion_type: IPromotionType;
  };
}

interface IFilterOmitValue extends Omit<IFilter, "value"> {
  value?:
    | string
    | string[]
    | Date[]
    | [null, null]
    | [undefined, undefined];    
}

export interface IFilterItem extends Omit<IFilterOmitValue, "apiKey"> {
  apiKey?: string | string[];
}

const Strings = {
  pageTitle: "Promotions",
  addPromotion: "Add Promotions",
  noRecordFounds: "No promotions found",
  view: "View",
  edit: "Edit",
  deactivate: "Deactivate",
  activate: "Activate",
  active: "Active"
};

const ApiUrls = {
  promotionsList: "bx_block_promotions/promotions",
  promotionDeactivate: "bx_block_promotions/promotions"
};
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  filters: IFilterItem[];
  sortingData: ISortingData;
  filterAnchor: { currentTarget: {} } | undefined | HTMLDivElement;
  totalCount: number;
  popOverTop: number;
  popOverLeft: number;
  endDate: Date | null | string | undefined;
  startDate: Date | null | string | undefined;
  popOverOpened: boolean;
  confirmModalFlag: boolean;
  confirmModalType: boolean;
  promotionsList: Array<IPromotionItem>;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
  isAppliedFilter: boolean;
  isLoading: boolean;
  // Customizable Area End
}

export interface SS {}

class PromotionsListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  filterQuery: string = "";
  searchQuery: string = "";
  currentPage: number = 1;
  rowPerPage: number = 10;
  sortQuery: string = "";

  promotionsListMessageId: string = "";
  confirmModalValue: string = "";
  popOverItemStatus: string = "";
  deactivateMessageId: string = "";
  popOverItemId: string | number = "";

  sortingProps = {
    width: "18%",
    onQueryChange: (query: string) => {
      this.sortQuery = query;
      this.getPromotionsApi();
    },
    onChange: (d: ISortingData) => this.setState({ sortingData: d }),
  };
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage)
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.extractDataFromLayout(message);
    this.gatherSearchTextData(message);
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    console.log("Received message - requestId:", requestId);
    console.log("Received message - promotionsListMessageId:", this.promotionsListMessageId);
    console.log("Received message - successResponse:", successResponse);

    if (successResponse) {
      if (requestId === this.promotionsListMessageId) {
        console.log("Processing promotions list response...");
        this.handlePromotionsListResponse(successResponse);
      } else if (requestId === this.deactivateMessageId) {
        this.handleDeactivateResponse(successResponse);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.setState({
      isLoadingPermission: true,
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
        activatePermission: false
      }
    });
    
    // Mock permission check - replace with actual permission logic
    setTimeout(() => {
      this.setState({
        isLoadingPermission: false,
        permissionStatus: {
          mainPermission: true,
          createPermission: true,
          viewPermission: true,
          editPermission: true,
          deactivatePermission: true,
          activatePermission: true
        }
      });
    }, 500);

    this.getPromotionsApi();
  }

  getPromotionsApi = () => {
    this.setState({ isLoading: true });

    let url = `${ApiUrls.promotionsList}?page=${this.currentPage}&per_page=${this.rowPerPage}`;
    
    if (this.sortQuery) {
      url += `&${this.sortQuery}`;
    }
    if (this.filterQuery) {
      url += `&${this.filterQuery}`;
    }
    if (this.searchQuery) {
      url += `&search=${this.searchQuery}`;
    }

    const requestMessage = MakeApiMessage({
      url: url,
      method: "GET",
    });

    this.promotionsListMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePromotionsListResponse = (responseJson: any) => {
    this.setState({ isLoading: false });
    
    console.log("API Response:", responseJson);
    console.log("Meta information:", responseJson?.meta);
    
    // Handle different possible response structures
    let promotionsData = [];
    let total = 0;
    
    if (responseJson) {
      // Update current page if provided in response
      if (responseJson.meta?.current_page) {
        this.currentPage = responseJson.meta.current_page;
      }
      
      // Based on your API response structure: {data: [...]}
      if (responseJson.data && Array.isArray(responseJson.data)) {
        console.log("Using responseJson.data structure");
        promotionsData = responseJson.data;
        total = responseJson.meta?.total_count || responseJson.meta?.total || responseJson.data.length || 0;
      } else if (Array.isArray(responseJson)) {
        console.log("Using direct array structure");
        promotionsData = responseJson;
        total = responseJson.length;
      } else {
        console.log("Unexpected response structure:", responseJson);
        console.log("Response keys:", responseJson ? Object.keys(responseJson) : "null");
        
        // Try to extract data anyway if it exists
        const possibleData = responseJson?.data || responseJson?.promotions || responseJson;
        if (Array.isArray(possibleData)) {
          promotionsData = possibleData;
          total = possibleData.length;
        }
      }
    }
    
    console.log("Final promotions data:", promotionsData);
    console.log("Final total count:", total);
    console.log("Current page:", this.currentPage);
    console.log("Rows per page:", this.rowPerPage);
    
    this.setState({
      promotionsList: promotionsData,
      totalCount: total
    });
  };

  onChangePage = (page: number) => {
    this.currentPage = page;
    this.getPromotionsApi();
  };

  handleRedirection = (screenName: string) => {
    this.props.navigation.navigate(screenName);
  };

  handleFilterChange = (event?: { currentTarget: {} }) => {
    this.setState({ filterAnchor: event?.currentTarget as HTMLDivElement });
  };

  onApplyFilter = (filters: IFilter[]) => {
    let query = "";
    let hasAppliedFilter = false;

    filters.forEach((filter) => {
      if (filter.value && filter.value !== "") {
        hasAppliedFilter = true;
        if (filter.title === "Date" && Array.isArray(filter.value)) {
          const [startDate, endDate] = filter.value;
          if (startDate && endDate) {
            query += `&start_date=${moment(startDate).format('YYYY-MM-DD')}`;
            query += `&end_date=${moment(endDate).format('YYYY-MM-DD')}`;
          }
        } else if (filter.apiKey) {
          query += `&${filter.apiKey}=${filter.value}`;
        }
      }
    });

    this.filterQuery = query;
    this.currentPage = 1;
    this.setState({ isAppliedFilter: hasAppliedFilter });
    this.getPromotionsApi();
  };

  handleReturnColorType = () => {
    return this.state.isAppliedFilter ? "primary" : "inherit";
  };

  onEditApi = (activate: boolean = false) => {
    const body = {
      data: {
        status: activate ? "active" : "inactive"
      }
    };

    const requestMessage = MakeApiMessage({
      url: `${ApiUrls.promotionDeactivate}/${this.popOverItemId}`,
      method: "PUT",
      body: JSON.stringify(body),
    });

    this.deactivateMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleDeactivateResponse = (responseJson: any) => {
    this.setState({
      popOverOpened: false,
      confirmModalFlag: false,
      confirmModalType: true
    });
    this.getPromotionsApi();
  };

  handleConfirmModal = () => {
    if (!this.state.confirmModalType) {
      this.onEditApi();
    } else {
      this.setState({
        confirmModalFlag: false,
        confirmModalType: false
      });
    }
  };

  extractDataFromLayout = (message: Message) => {
    const layoutDataMessage = message.getData(
      getName(MessageEnum.LayoutDataMessage)
    );

    if (layoutDataMessage) {
      const userContext = layoutDataMessage as IUserContext;
      if (userContext) {
        // Handle layout data if needed
      }
    }
  };

  gatherSearchTextData = (message: Message) => {
    const searchTextMessage = message.getData(
      getName(MessageEnum.SearchTextMessage)
    );

    if (searchTextMessage) {
      this.searchQuery = searchTextMessage;
      this.currentPage = 1;
      this.getPromotionsApi();
    }
  };
  // Customizable Area End
}

export default PromotionsListController;